module.exports = __webpack_public_path__ + "img/rw.c660ab03.svg";